/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useContext } from 'react';
import { useFormikContext } from 'formik';

import { getCommunicateTo, putCommunicateTo } from '../../services/serviceRequest';
import LoaderContext from '../../context/LoaderProvider';
import { CommunicateToPermissions } from '../MonthlyServiceRequest/RequestDetailTypes';
import { DetailRequest, DetailRequestDefaultProp } from '../../utils/globalPropTypes';
import { statusEnum, ubicationTypeEnum } from '../../utils/dataStatus';
import CommunicateForm from '../CommunicateForm/CommunicateForm';
import useToast from '../../hooks/useToast';

const CommunicateToForm = ({ details, communicateToPermissions }) => {
  const { values, setFieldValue, setFieldTouched, errors, touched } = useFormikContext();
  const { setNewToast } = useToast();
  const { setLoader } = useContext(LoaderContext);
  const [defaultReceivers, setDefaultReceivers] = useState([]);
  const [inspectors, setInspectors] = useState([]);
  const stateCancelOrFinish =
    details.estadoEnum === statusEnum.cancelada || details.estadoEnum === statusEnum.finalizada;

  const isInvalidWithCopyTo =
    errors?.communicate?.aditionalReceivers && touched?.communicate?.aditionalReceivers
      ? !!touched?.communicate?.aditionalReceivers && !!errors?.communicate?.aditionalReceivers
      : false;
  const isOyM =
    details?.tipoUbicacion?.id !== ubicationTypeEnum.pozo &&
    details?.tipoUbicacion?.id !== ubicationTypeEnum.locacion;

  const fetchDefaultReceivers = async () => {
    setLoader(true);
    try {
      const response = await getCommunicateTo(details.id);

      const adaptedReceivers = response.destinatarioComunicarA.map((r) => ({
        label: r.nombre
      }));

      const adaptedInspectors = response.inspectores.map((i) => ({
        label: i.nombre
      }));

      setDefaultReceivers(adaptedReceivers);
      setInspectors(adaptedInspectors);
      const destinatarios = response.destinatarioConCopia.map((destinatario) => ({
        id: destinatario.id,
        nombre: destinatario.nombre,
        label: destinatario.nombre,
        value: destinatario.id
      }));

      setFieldValue('communicate.aditionalReceivers', destinatarios);
    } catch (error) {
      setNewToast(error.message);
    } finally {
      setLoader(false);
    }
  };

  const updateReceivers = async (val) => {
    await putCommunicateTo(val, details.id);
  };

  const handleSelectChange = async (val) => {
    try {
      setLoader(true);
      await updateReceivers(val);
      setFieldValue('communicate.aditionalReceivers', val);
      setFieldTouched('communicate.aditionalReceivers');
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchDefaultReceivers();
  }, [values?.provider?.providers]);

  return (
    <CommunicateForm
      communicateToForm
      defaultReceivers={defaultReceivers}
      inspectors={inspectors}
      isOyM={isOyM}
      selectProps={{
        businessUnitId: details.unidadNegocio.id,
        errors: errors?.communicate?.aditionalReceivers,
        isDisabled: stateCancelOrFinish || !communicateToPermissions.write,
        isInvalid: isInvalidWithCopyTo,
        onChange: handleSelectChange,
        value: values?.communicate?.aditionalReceivers
      }}
    />
  );
};

CommunicateToForm.propTypes = {
  communicateToPermissions: CommunicateToPermissions.isRequired,
  details: DetailRequest
};
CommunicateToForm.defaultProps = {
  details: DetailRequestDefaultProp
};

export default CommunicateToForm;
